<template>
  <!-- <div class="video-back"
  > -->
  <div class="video-back"
  view-mode="h" view-rotation="auto" view-scale="height" view-width="2900" view-height="1280" view-align=""
  >
  <div :class="hiddenBg?' progress hiddenProgress':'progress'">

  </div>
  <video class="compatibleStyle" id="video" ></video>
    <!-- <video
      id="video"
      ref="video"
      class="video-tag"
      :src="src"
      autoplay
      muted
      preload
    ></video> -->
    <div ref="c_box" class="click-box" v-if="currentStatus == 'loop'">
      <div
        :class="
          tag.type === 'padding'
            ? 'box_btn btn_anim'
            : tag.display_type === 'nonel'
            ? 'box_btn btn_anim curr'
            : 'box_btn btn_anim getfocus'
        "
        v-for="(tag, index) in currentPlayItem.tags"
        :style="getBtnPos(tag)"
        :key="index"
        @click="
          clickTag(
            tag,
            {
              img: currentPlayItem.tag_img,
              name: tag.name,
              current: currentPlayItem
            },
            index
          )
        "
      >
        <div class="box_btn_back">
          <template v-if="tag.type == 'jumpVideo'">
            <!-- 二级跳转按钮 -->
            <div
              v-if="tag.grade && tag.grade === 'one'"
              :class="resolving !== 1920 ? 'box-img ' : 'box-img1920 '"
              :style="{
                'background-image':
                  'url(' + currentPlayItem.tag_img[index] + ')'
              }"
            >
              {{ tag.name }}
            </div>
            <!-- 二级跳转按钮 -->
            <div
              :class="resolving !== 1920 ? 'box-img compatibleStyle' : 'box-img1920 compatibleStyle '"
              :style="{
                'background-image': 'url(' + currentPlayItem.tag_img + ')'
              }"
              v-else
            >
              {{ tag.name }}
            </div>
            <img
              v-if="tag.explain_imgs"
              :id="
                tag.name === 'EI工业智能体@钢铁' ? 'steel_imgs' : 'explain_imgs'
              "
              :src="currentPlayItem.explain_imgs[index]"
            />
          </template>
          <template v-else>
            <!-- 三级弹窗按钮 -->
            <div
              :class="
                resolving !== 1920 && tag.type != 'padding'
                  ? 'box-img-three allow_click_color'
                  : resolving !== 1920 && tag.type == 'padding'
                  ? 'box-img-three'
                  : resolving === 1920 && tag.type !== 'padding'
                  ? 'box-img-three-1920 allow_click_color'
                  : 'box-img-three-1920'
              "
              :style="{
                'background-image': 'url(' + tag.img_bg + ')'
              }"
            >
              {{ tag.name }}
            </div>
          </template>
        </div>
      </div>
      <!-- 隐藏的跳转的div -->
      <div v-if="this.$store.state.selectContent.lenght !== 0">
        <div
          v-for="content in this.$store.state.selectContent"
          :key="content.name"
          :style="getBtnPos(content)"
          class="content"
          @click="contentFadeIn(content)"
        ></div>
      </div>
    </div>
    <SingleVideoPop
      :data="popData"
      :status="singleVideoStatus"
      @close-pop="singleVideoStatus = false"
    ></SingleVideoPop>
    <ImgVideoMixPop
      :data="popData"
      :status="imgVideoStatus"
      @close-pop="imgVideoStatus = false"
    ></ImgVideoMixPop>
    <FullPageImgPop
      :data="popData"
      :status="fullImgStatus"
      @close-pop="fullImgStatus = false"
    ></FullPageImgPop>
    <TabVideoPop
      :data="popData"
      :status="tabVideoStatus"
      @close-pop="tabVideoStatus = false"
    />
    <PagerPop
      :data="popData"
      :status="pagerPopStatus"
      @close-pop="pagerPopStatus = false"
    />
   <SpecialVideoPop
      :data="popData"
      :status="SpecialVideoPopStatus"
      @close-pop="SpecialVideoPopStatus = false"
    />
    <div
        class="close"
        v-if="playTagName != 'home' && this.$store.state.globalHomeStatus"
        @click="closeTag"
      >
        <img
          v-if="this.$store.state.homeBack"
          :src="
            'https://res-static.hc-cdn.cn/cloudbu-site/china/zh-cn/关于华为云/exibihition/Hall/ui/home_back.png'
          "
        />
      </div>
    <!-- 三个按钮 -->
    <div class="img-list" v-if="this.$store.state.imgListStatus">
      <div class="explain">
        <a href="https://www.huaweicloud.com/about/exibihition/index.html">
          <div class="select-img-gohome"></div>
        </a>
      </div>
      <div class="explain-server">
        <a href="https://www.huaweicloud.com/consultation/">
        <div class="select-img-serve"></div>
          </a>
      </div>
      <div class="explain-load" @click="load_wrap = true">
        <div class="select-img-load"></div>
      </div>
    </div>
    <template v-if="selectTag">
        <div
        style="cursor: pointer"
        class="box_btn_left_back"
        v-if="
          playStatus == 'loop' &&
            playTagName != 'home' &&
            this.$store.state.globalBackStatus"
          @click="clickBtnPre"
        >
        <img :src="selectTag.img" v-if="this.$store.state.selectTagImg" />
        <div
          class="box_selectTagImg_name"
          v-if="this.$store.state.selectTagImg">
          <span style="padding-right: 5px; margin-left: 80px;font-size:27px">←{{ selectTag.name }}</span>
        </div>
      </div>
    </template>
    <div class="load_wrap" v-if="load_wrap">
      <div class="code_wrap">
        <div class="qrCode">
          <img
            class="code"
            src="https://res-static.hc-cdn.cn/cloudbu-site/china/zh-cn/关于华为云/exibihition/Hall/ui/xin-zeng/QR-ccode/qrCode.png"
            alt="二维码"
          />
          <img
            @click="load_wrap = false"
            class="close-img"
            src="https://res-static.hc-cdn.cn/cloudbu-site/china/zh-cn/关于华为云/exibihition/Hall/ui/xin-zeng/close/close.png"
            alt="二维码"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SingleVideoPop from "@com/SingleVideoPop.vue";
import ImgVideoMixPop from "@com/ImgVideoMixPop.vue";
import FullPageImgPop from "@com/FullPageImgPop.vue";
import TabVideoPop from "@com/TabVideoPop.vue";
import PagerPop from "@com/PagerPop.vue";
import SpecialVideoPop from "@com/SpecialVideoPop.vue";
export default {
  props: {
    videoData: Object
  },
  components: {
    SingleVideoPop,
    ImgVideoMixPop,
    FullPageImgPop,
    TabVideoPop,
    PagerPop,
    SpecialVideoPop
  },
  data() {
    return {
      src: "",
      map: new Map(),
      currentTagName: "",
      startTime: 0,
      endTime: 0,
      currentPlayItem: null,
      currentStatus: "",
      selectTag: null,
      showTabBox: false,
      screenStyle: {
        width: 0,
        height: 0
      },
      currentInVideoStack: [],
      toHome: false,
      isToHomeEnd: false,
      popData: {},
      singleVideoStatus: false,
      imgVideoStatus: false,
      fullImgStatus: false,
      tabVideoStatus: false,
      pagerPopStatus: false,
      SpecialVideoPopStatus: false,
      resolving: "",
      speciaIndexOne: 0,
      speciaIndexTwo: 0,
      speciaIndexThree: 0,
      commitIndex: 0,
      // 用来判断进入还是循环
      speciaStatus: null,
      speciaPlayItem: null,
      videoPlayer:null,
      hiddenBg:false,
      load_wrap: false,
      //selectTagAll:null
      //selectTag: null,
    };
  },
  created() {
    if (window.screen.width <= 1920 && window.screen.width > 1366) {
      this.resolving = 1920;
    } else if (window.screen.width > 1920) {
      this.resolving = 1920;
    }
  },
  computed:{
    playStatus() {
      return this.currentStatus 
    },
    playTagName(){
      return this.currentPlayItem &&this.currentPlayItem.name;
    }
  },
  methods: {
    clickBtnPre(){
      if (this.selectTag.content !== undefined) {
        this.$store.commit("setSelectContent", this.selectTag.content);
      } else {
        this.$store.commit("setSelectContent", []);
      }
      console.log(this.$store.state.selectContent);
      this.fadeNextOne();
      this.$store.commit("setSpeciaStatus", null);
    },
    clickVideo() {
      this.initTagName("home");
    },
    clickTag(tag, selectTag, index) {
      console.log(tag,selectTag,index,'dfdfd')
      this.isToHomeEnd = false;
      this.toHome = false;
      //this.selectTagAll = selectTag;
      switch (tag.type) {
        case "jumpVideo":
          console.log('jumpvideo')
          if (tag.status && tag.status === "existence") {
            var List = {
              fadeIn: tag.fadeIn,
              loop: tag.loop
            };
            this.speacialSwitch(List, tag.name);
            this.speciaPlayItem = List;
          } else if (tag.status && tag.status === "special") {
            console.log('special')
            this.currentInVideoStack.push(tag.to);
            this.initTagName(tag.to);
            this.selectTag={
               name: selectTag.name,
              img: selectTag.img,
              content: this.$store.state.selectContent
            }
            console.log(this.selectTag,'selected')
            // this.$emit("selected", {
            //   name: selectTag.name,
            //   img: selectTag.img,
            //   content: this.$store.state.selectContent
            // });
            this.$store.commit("setSelectContent", []);
          } else {
            if (tag.grade && tag.grade === "one") {
              const objTag = {
                name: selectTag.name,
                img: selectTag.img[index]
              };
              this.selectTag = objTag
              console.log('objTag',objTag)
              //this.$emit("selected", objTag);
            } else {
               console.log('selected')
              this.selectTag = selectTag
              //this.$emit("selected", selectTag);
            }
            this.currentInVideoStack.push(tag.to);
            this.initTagName(tag.to);
            if (tag.content !== undefined) {
              this.$store.commit("setSelectContent", tag.content);
            }
          }
          break;
        case "openImgVideoMixPop":
          this.popData = tag.content;
          this.imgVideoStatus = true;
          break;
        case "openSingleVideoPop":
          this.hideBack();
          switch (tag.opentype) {
            case "openTabVideoPop":
              this.popData = tag.content;
              this.tabVideoStatus = true;
              this.$store.commit("setImgListStatus", false);
              break;
            case "openMixPop":
              this.popData = tag.content;
              this.imgVideoStatus = true;
              this.$store.commit("setImgListStatus", false);
              break;
            case "openPagerPop":
              this.popData = tag.content;
              this.pagerPopStatus = true;
              this.$store.commit("setImgListStatus", false);
              break;
            case "openSpecialVideoPop":
              this.popData = tag.content;
              this.SpecialVideoPopStatus = true;
              this.$store.commit("setImgListStatus", false);
              break;
          }
          break;
        case "fullImgPop":
          this.popData = tag.content;
          this.fullImgStatus = true;
          this.$store.commit("setGlobalBack", false);
          this.$store.commit("setGlobalHome", false);
          break;
      }
    },
    speacialSwitch(List, name) {
      if (name === "信息化基本完成") {
        switch (this.speciaIndexOne) {
          case 0:
            this.specialTagName(List, this.speciaIndexOne);
            this.speciaIndexOne = 2;
            break;
          case 2:
            this.specialTagName(List, this.speciaIndexOne);
            this.speciaIndexOne = 4;
            break;
          case 4:
            this.specialTagName(List, this.speciaIndexOne);
            this.speciaIndexOne = 6;
            break;
          case 6:
            this.specialTagName(List, this.speciaIndexOne);
            this.speciaIndexOne = 0;
            break;
        }
      } else if (name === "未实现信息化") {
        switch (this.speciaIndexTwo) {
          case 0:
            this.specialTagName(List, this.speciaIndexTwo);
            this.speciaIndexTwo = 2;
            break;
          case 2:
            this.specialTagName(List, this.speciaIndexTwo);
            this.speciaIndexTwo = 4;
            break;
          case 4:
            this.specialTagName(List, this.speciaIndexTwo);
            this.speciaIndexTwo = 6;
            break;
          case 6:
            this.$store.commit("setSpeciaStatus", "loop");
            this.startTime = this.speciaPlayItem.loop[this.speciaIndexTwo];
            this.endTime = this.speciaPlayItem.loop[this.speciaIndexTwo + 1];
            this.videoPlayer.currentTimeAndPlay = this.startTime;
            this.speciaIndexTwo = 0;
            break;
        }
      } else {
        switch (this.speciaIndexThree) {
          case 0:
            this.specialTagName(List, this.speciaIndexThree);
            this.speciaIndexThree = 2;
            break;
          case 2:
            this.specialTagName(List, this.speciaIndexThree);
            this.speciaIndexThree = 4;
            break;
          case 4:
            this.$store.commit("setSpeciaStatus", "loop");
            this.startTime = this.speciaPlayItem.loop[this.speciaIndexThree];
            this.endTime = this.speciaPlayItem.loop[this.speciaIndexThree + 1];
            this.videoPlayer.currentTimeAndPlay = this.startTime
            //this.videoPlayer.currentTime = this.startTime;
            this.speciaIndexThree = 6;
            break;
          case 6:
            this.specialTagName(List, this.speciaIndexThree);
            this.speciaIndexThree = 0;
            break;
        }
      }
    },
    specialTagName(List, index) {
      if (this.$store.state.speciaStatus === "fadeIn") {
        return;
      }
      this.$store.commit("setSpeciaStatus", "fadeIn");
      if (List.fadeIn) {
        this.startTime = List.fadeIn[index];
        this.endTime = List.fadeIn[index + 1];
        this.videoPlayer.currentTimeAndPlay = this.startTime
        //this.videoPlayer.currentTime = this.startTime;
        this.commitIndex = index;
        // this.$refs.video.removeAttribute("autoplay");
      }
    },
    // getVideoTag() {
    //   return this.videoPlayer;
    //   //return this.$refs.video;
    // },
    initTagName(name) {
      
      this.currentPlayItem = this.map.get(name);
      console.log(this.currentPlayItem,'currentPlayItem')
      this.fadeInTagName();
    },
    fadeInTagName() {
      if (this.currentStatus === "fadeIn") {
        return;
      }
      this.currentStatus = "fadeIn";
      let item = this.currentPlayItem;
      if (item.fadeIn) {
        this.startTime = item.fadeIn[0];
        this.endTime = item.fadeIn[1];
        this.videoPlayer.currentTimeAndPlay = this.startTime
        //this.videoPlayer.currentTime = this.startTime;
      } else if (item.loop) {
        this.loopTagName();
      }
    },
    loopCurrentOne() {
      if (this.currentInVideoStack.length > 0) {
        let name = this.currentInVideoStack[
          this.currentInVideoStack.length - 1
        ];
        this.currentPlayItem = this.map.get(name);
        this.loopTagName();
      } else {
        this.initTagName("home");
      }
    },
    loopBackTagName() {
      if (this.currentInVideoStack.length > 0) {
        let name = this.currentInVideoStack.pop();
        this.currentPlayItem = this.map.get(name);
        console.log()
        this.loopTagName(this.currentInVideoStack.length,'this.currentInVideoStack.length');
      } else {
        this.initTagName("home");
      }
    },
    loopTagName() {
      if (this.currentTagName === "loop") {
        return;
      }
      let item = this.currentPlayItem;
      this.currentStatus = "loop";
      this.startTime = item.loop[0];
      this.endTime = item.loop[1];
      this.videoPlayer.currentTimeAndPlay = this.startTime
      //this.getVideoTag().currentTime = this.startTime;
    },
    restartLoopTagName() {
      this.videoPlayer.currentTimeAndPlay = this.startTime
      //this.videoPlayer.currentTime = this.startTime;
    },
    fadeOutTagName() {
      if (this.currentStatus === "fadeOut") {
        return;
      }
      this.currentStatus = "fadeOut";
      let item = this.currentPlayItem;
      if (item.fadeOut) {
        this.startTime = item.fadeOut[0];
        this.endTime = item.fadeOut[1];
        this.videoPlayer.currentTimeAndPlay = this.startTime
        //this.videoPlayer.currentTime = this.startTime;
      }
    },
    fadeNextOne() {
      this.showTabBox = false;
      if (this.currentInVideoStack.length > 0) {
        let name = this.currentInVideoStack.pop();
        this.currentPlayItem = this.map.get(name);

        this.loopTagName();
        this.fadeOutTagName();
        if (this.currentInVideoStack.length <= 0) {
          this.isToHomeEnd = true;
        } else {
          let lastName = this.currentInVideoStack[
            this.currentInVideoStack.length - 1
          ];
          let tagItem = this.map.get(lastName);
          this.selectTag = {
            img: tagItem.tag_img,
            name: tagItem.desc
          };
          
         // this.$emit("selected", this.selectTag);
        }
      } else {
        this.loopTagName();
        this.fadeOutTagName();
        this.isToHomeEnd = true;
        this.$emit("selected", null);
      }
    },
    closeTag() {
      this.toHome = true;
      // 关闭视频弹出层
      this.imgVideoStatus = false;
      this.singleVideoStatus = false;
      //
      this.fadeNextOne();
      this.$emit("selected", null);
      this.$store.commit("setSpeciaStatus", null);
    },
   
    getBtnPos(item) {
      
      if (item.pos) {
        console.log(item,'item')
        if(item.name=='物流仓储'){
           return {
            left: (item.pos[0] / 2674) * 100 + "%",
            // top: (item.pos[1] / 1080) * 100 + "%"
            top: (item.pos[1] / 2500) * 100 + "%"
          }; 
        } else{
          return {
            left: (item.pos[0] / 2500) * 100 + "%",
            // top: (item.pos[1] / 1080) * 100 + "%"
            top: (item.pos[1] / 1052) * 100 + "%"
          };
        }

        
      } else if (item.rect) {
        return {
          left: (item.rect[0] / 2500) * 100 + "%",
          top: (item.rect[1] / 1080) * 100 + "%",
          width: (item.rect[2] / 1080) * 100 + "%",
          height: (item.rect[3] / 1080) * 100 + "%"
        };
      } else if (item.position) {
        return {
          left: (item.position.left / 2500) * 100 + "%",
          top: (item.position.top / 1080) * 100 + "%",
          width: (item.position.width / 1080) * 100 + "%",
          height: (item.position.height / 1080) * 100 + "%"
        };
      }
    },
    update() {
      let item = this.currentPlayItem;
      let video = this.videoPlayer;
      let c_box = this.$refs.c_box;
      c_box && (c_box.style.width = video.clientWidth);
      // 正常进入循环退出
      if (this.currentStatus == "fadeIn") {
        if (!item.fadeIn || video.currentTime >= this.endTime - 0.016) {
          video.currentTimeAndPause = this.endTime
          //video.currentTime = this.endTime;
          this.loopTagName();
        }
      }
      if (this.currentStatus == "loop") {
        if (video.currentTime >= this.endTime - 0.016) {
          video.currentTimeAndPause = this.endTime
          //video.currentTime = this.endTime;
          this.restartLoopTagName();
        }
      }
      if (this.currentStatus == "fadeOut") {
        if (!item.fadeOut || video.currentTime >= this.endTime - 0.016) {
          video.currentTimeAndPause = this.endTime
          //video.currentTime = this.endTime;
          if (this.toHome) {
            if (this.isToHomeEnd) {
              this.initTagName("home");
            } else {
              this.fadeNextOne();
            }
          } else {
            this.loopCurrentOne();
          }
          // this.initTagName("home");
        }
      }
      //特殊的
      if (this.$store.state.speciaStatus == "fadeIn") {
        if (video.currentTime >= this.endTime - 0.032) {
         video.currentTimeAndPause = this.endTime
         // video.currentTime = this.endTime;
          if (this.$store.state.speciaStatus === "loop") {
            return;
          }

          this.$store.commit("setSpeciaStatus", "loop");
          this.startTime = this.speciaPlayItem.loop[this.commitIndex];
          this.endTime = this.speciaPlayItem.loop[this.commitIndex + 1];
          this.videoPlayer.currentTimeAndPlay = this.startTime
          //this.videoPlayer.currentTime = this.startTime;
        }
      }
      if (this.$store.state.speciaStatus == "loop") {
        if (video.currentTime >= this.endTime - 0.024) {
          video.currentTimeAndPause = this.endTime
          //video.currentTime = this.endTime;
          this.restartLoopTagName();
        }
      }
    },
    //隐藏左上后退和右上回家按钮
    hideBack() {
      this.$store.commit("setHomeBack", false);
      this.$store.commit("setSelectTagImg", false);
    },
    // 点击隐藏div切换视频进度
    contentFadeIn(content) {
      // if (content.fadeIn) {
      this.currentInVideoStack.push(content.to);
      this.initTagName(content.to);
      this.$emit("selected", {
        name: content.name,
        img: content.img,
        content: this.$store.state.selectContent
      });
      this.$store.commit("setSelectContent", []);
      // } else if (content.loop) {
      //
      //   this.loopTagName();
      // }
      //
    },
    begin(src){
      this.videoPlayer = new  MMD.VideoPlayer({
        videoElement:document.getElementById('video'),//[必填],video元素;
        src:src,//[必填],video src;
        loop: false,//[可选],是否循环,默认false,true为循环;
        muted: true,//[可选],是否静音,默认false,IOS下只有IOS10生效,安卓生效;
        poster: '',
        isVideoCanAutoPlay:true,//当isVideoCanAutoPlay属性为true时,则代表允许自动播放;
        //tryMultipleVideoPlayAtTheSameTime: false,
        timesParam: [],//[可选],video currenttime时间点;
        onStart: function () {//[可选],video第一个画面出现回调;
        },
        onEnd: function () {//[可选],video播放完成回调;
        }
     
    })
     this.videoPlayer.replay()
    }
  },
  mounted() {
   
    let update = () => {
      this.update();
      window.requestAnimationFrame(update);
    };
    // window.resize = () => {
    //   this.screenStyle = {
    //     width: window.innerWidth/2900,
    //     height: window.innerHeight/1280
    //   };
    // };
    // this.screenStyle = {
    //   width: window.innerWidth/2900,
    //   height: window.innerHeight/1280
    // };

    // window.resize = () => {
    //   this.screenStyle = {
    //     width: window.innerWidth + "px",
    //     height: window.innerHeight + "px"
    //   };
    // };
    // this.screenStyle = {
    //   width: window.innerWidth + "px",
    //   height: window.innerHeight + "px"
    // };
    window.requestAnimationFrame(update);
    this.src = this.videoData.src;
   
    this.videoData.animation.forEach(item => {
      this.map.set(item.name, item);
    });
   
    this.$nextTick(() => {
      this.begin(this.videoData.src)
      this.clickVideo();
      this.hiddenBg = true
        // this.$refs.video.play();
    });
  }
};
</script>

<style lang="scss" scope>

 #video {
       height: 100%;
      // position: absolute;
      // height: 1280px;
      // width: 2900px;
      // left: 0;
      // top: 0;
  }
.hiddenProgress{
  display: none !important;
}
.progress {
  display: block;
  width: 100%;
  height: 100%;
  background: #efefef;
  background: url('../../public/ui/xin-zeng/bg/video_bg.png') no-repeat center center / 100% 100%;
}
.close {
  cursor: pointer;
    position: absolute;
    right: 299px;
    top: 56px;
    width: 85px;
    height: 92px;
  img {
    width: 100%;
  }
}
.close:hover {
  transform: scale(1.1, 1.1);
  cursor: pointer;
}
.img-list {
  // width: 100%;
  // height: 100%;
  // position: absolute;
  // left: 0;
  // top: 0;
  display: block;
  // z-index: 99;
  font-family: "方正兰亭中黑";
  .explain{
    cursor: pointer;
    position: absolute;
    right: 254px;
    top: 182px;
    z-index: 100;
     color: #ffffff;
     .select-img-gohome{
        width: 164px;
        height: 135px;
        background: url("https://res-static.hc-cdn.cn/cloudbu-site/china/zh-cn/关于华为云/exibihition/Hall/ui/xin-zeng/btn/gohome.png") no-repeat center / 100%;
        background-size: cover;
     }
     .select-img-gohome:hover{
        background: url("https://res-static.hc-cdn.cn/cloudbu-site/china/zh-cn/关于华为云/exibihition/Hall/ui/xin-zeng/btn/gohome_select.png") no-repeat center / 100%;
        background-size: cover;
     }
  }
  .explain-server{
    position: absolute;
    right: 280px;
    top: 315px;
    cursor: pointer;
    z-index: 100;
    color: #ffffff;
    .select-img-serve{
      width: 111px;
      height: 132px;
      background: url("https://res-static.hc-cdn.cn/cloudbu-site/china/zh-cn/关于华为云/exibihition/Hall/ui/xin-zeng/btn/serve.png") no-repeat center / 100%;
      background-size: cover;
    }
    .select-img-serve:hover{
      background: url("https://res-static.hc-cdn.cn/cloudbu-site/china/zh-cn/关于华为云/exibihition/Hall/ui/xin-zeng/btn/serve_select.png") no-repeat center / 100%;
      background-size: cover;
    }
  }
  .explain-load{
    position: absolute;
    // right: 199px;
    right: 280px;
    top: 450px;
    cursor: pointer;
    color: #ffffff;
    z-index: 100;
    .select-img-load {
      // width: 112px;
      width: 108px;
      height: 135px;
      background: url("https://res-static.hc-cdn.cn/cloudbu-site/china/zh-cn/关于华为云/exibihition/Hall/ui/xin-zeng/btn/load.png") no-repeat center / 100%;
      background-size: cover;
    }
    .select-img-load:hover{
      background: url("https://res-static.hc-cdn.cn/cloudbu-site/china/zh-cn/关于华为云/exibihition/Hall/ui/xin-zeng/btn/load_select.png") no-repeat center / 98%;
      background-size: cover;
    }
  }
}
// .img-list {
//    position: absolute;
//   top: 120px;
//   right: 200px;
//   display: flex;
//   flex-direction: column;
 
//   font-family: "方正兰亭中黑";
//   .explain {
//     cursor: pointer;
//     text-align: center;
//     color: #ffffff;
//     margin-bottom: 0px;
//     .select-img-gohome {
//       width: 123px;
//       height: 100px;
//       background-image: url("https://res-static.hc-cdn.cn/cloudbu-site/china/zh-cn/关于华为云/exibihition/Hall/ui/xin-zeng/btn/gohome.png");
//       background-size: cover;
//     }
//     .select-img-gohome:hover {
//       background-image: url("https://res-static.hc-cdn.cn/cloudbu-site/china/zh-cn/关于华为云/exibihition/Hall/ui/xin-zeng/btn/gohome_select.png");
//     }
//     .select-img-serve {
//       width: 85px;
//       height: 102px;
//       background-image: url("https://res-static.hc-cdn.cn/cloudbu-site/china/zh-cn/关于华为云/exibihition/Hall/ui/xin-zeng/btn/serve.png");
//       background-size: cover;
//       margin-left: 20px;
//     }
//     .select-img-serve:hover {
//       background-image: url("https://res-static.hc-cdn.cn/cloudbu-site/china/zh-cn/关于华为云/exibihition/Hall/ui/xin-zeng/btn/serve_select.png");
//     }
//     .select-img-load {
//       width: 85px;
//       height: 102px;
//       background-image: url("https://res-static.hc-cdn.cn/cloudbu-site/china/zh-cn/关于华为云/exibihition/Hall/ui/xin-zeng/btn/load.png");
//       background-size: cover;
//       margin-left: 20px;
//     }
//     .select-img-load:hover {
//       background-image: url("https://res-static.hc-cdn.cn/cloudbu-site/china/zh-cn/关于华为云/exibihition/Hall/ui/xin-zeng/btn/load_select.png");
//     }
//   }
// }
.back_mask {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  background-color: rgba(0, 0, 0, 0.7);
  .prop {
    .title {
      position: fixed;
      color: #b82528;
      font-size: 3.2vh;
      font-weight: bold;
      top: 9%;
      left: 7%;
    }
    .subhead {
      position: fixed;
      font-size: 3vh;
      color: #ffffff;
      font-weight: bold;
      top: 9%;
      left: 40%;
    }
    .video {
      position: fixed;
      top: 15.5%;
      left: 1.25%;
      width: 97.4%;
      height: 76.5%;
      object-fit: fill;
    }
    .close {
      width: 5vh;
      height: 5vh;
      background: url("https://res-static.hc-cdn.cn/cloudbu-site/china/zh-cn/关于华为云/exibihition/Hall/ui/close.png");
      background-size: 100% 100%;
      position: absolute;
      right: 0vh;
      top: 4vh;
    }
    .close:hover {
      transform: scale(1.1, 1.1);
    }
    position: absolute;
    width: 158vw;
    height: 190vh;
    background-color: white;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
}
.select-tag {
  position: absolute;
  left: 2vw;
  top: 2vh;
  width: 24%;
  img {
    width: 100%;
  }
  .close {
    width: 2vw;
    height: 2vw;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .box_btn_name {
    position: absolute;
    top: 50%;
    left: 50%;
    font-size: 12px;
    transform: translate(-50%, -70%);
  }
}
.screen-wh {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
}
.video-back {
  // height: 100%;
  // position: absolute;
  // left: 50%;
  // transform: translateX(-50%);
  // top: 0;
  .click-box {
    height: 100%;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    .box_btn {
      position: absolute;
      width: 15%;
      // img {
      //   width: 100%;
      //   height: 2.6vw;
      // }
      .box_btn_back {
        position: relative;
      }
      .box_btn_name {
        position: absolute;
        top: 50%;
        left: 50%;
        font-size: 1.8vh;
        transform: translate(-60%, -70%);
      }
      .allow_click_color {
        color: #1374ba;
      }
    }
    .getfocus {
      opacity: 0.8;
    }
    .getfocus:hover {
      opacity: 1;
      cursor: pointer;
    }
  }
  .video-tag {
    height: 100%;
  }
}
</style>
<style lang="scss" scope>
.box_btn_left_back {
  width: 500px;
  height: 90px;
  position: absolute;
  // left: 2vw;
   left:290px;
  top: 4vh;
  img {
    width: 500px;
    height: 90px;
  }
  .box_selectTagImg_name {
    position: relative;
    white-space: nowrap;
    text-align: center;
    width: 450px;
    height: 90px;
    top: -80px;
    line-height: 50px;
  }
}
// 新增的div样式
.content {
  position: absolute;
  cursor: pointer;
  // background-color: red;
}
.curr {
  cursor: pointer;
}
.box-img {
  position: absolute;
  line-height: 40px;
  text-indent: 70px;
  padding-right: 48px;
  padding-top: 8px;
  padding-bottom: 8px;
  background-size: 100% 100%;
  font-size: 25px;
  height: 44px;
}
.box-img1920 {
    position: absolute;
    line-height: 50px;
    text-indent: 59px;
    padding-right: 45px;
    padding-top: 1px;
    padding-bottom: 6px;
    background-size: 100% 100%;
    font-size: 22px;
    height: 55px;
    left: 24px;
    top: -14px;
}
.box-img-three {
  position: absolute;
  line-height: 65px;
  white-space: nowrap;
  padding-left: 81px;
  padding-right: 66px;
  padding-top: 5px;
  padding-bottom: 5px;
  display: inline-block;
  background-size: 100% 100%;
  font-size: 35px;
  height: 65px;
}
.box-img-three-1920 {
  position: absolute;
  line-height: 50px;
  white-space: nowrap;
  text-indent: 47px;
  padding-right: 42px;
  // padding-top: 2px;
  padding-bottom: 2px;
  display: inline-block;
  background-size: 100% 100%;
  text-align: left;
  font-size: 20px;
  height: 50px;
}

#explain_imgs {
  position: relative;
  width: 519px;
  top: 40px;
  right: 110px;
}

#steel_imgs {
  position: relative;
  width: 725px;
  bottom: -111px;
  left: calc(50% - 189px);

}
.touch {
  position: absolute;
  bottom: 27px;
  left: 50%;
  transform: translate(-50%);
  background-image: url("https://res-static.hc-cdn.cn/cloudbu-site/china/zh-cn/关于华为云/exibihition/Hall/ui/new_img/touch.png");
  font-size: 24px;
  font-weight: 500;
  width: 229px;
  height: 68px;
  text-align: center;
  line-height: 68px;
}
.compatibleStyle {
    // backface-visibility: hidden;
    // -webkit-backface-visibility: hidden;
    // /* Chrome 和 Safari */
    // -moz-backface-visibility: hidden;
    // /* Firefox */
    // -ms-backface-visibility: hidden;
    // /* Internet Explorer */
    // -webkit-perspective: 0;
    // -webkit-transform: translate3d(0, 0, 0);
    // visibility: visible;
}
.load_wrap {
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  // position: absolute;
  top: 0px;
  left: 0px;
  z-index: 5000;
  // display: none;
}
.code_wrap {
  width: 600px;
  height: 450px;
  background-color: rgba(0, 0, 0, 0.5);
  position: absolute;
  top: 50%;
  left: 50%;
  margin-left: -300px;
  margin-top: -225px;
  border-radius: 10px;
  .qrCode {
    position: relative;
    width: 600px;
    height: 450px;
    .code {
      position: absolute;
      top: 50%;
      left: 50%;
      margin-left: -150px;
      margin-top: -150px;
      width: 300px;
      height: 300px;
    }
    .close-img {
      cursor: pointer;
      position: absolute;
      right: -30px;
      top: -30px;
      width: 60px;
      height: 60px;
    }
  }
}
</style>

Powered by Gitea 当前版本: 1.12.3 页面: 24ms 模板: 3ms JavaScript licenses API
官方网站 Go1.14.6
